import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, getDocs, query, where } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

const MARKETS = [
  { id: "EGX", name: "Egyptian Exchange", flag: "🇪🇬" },
  { id: "TADAWUL", name: "Saudi Stock Exchange", flag: "🇸🇦" },
  { id: "ADX", name: "Abu Dhabi", flag: "🇦🇪" },
  { id: "DFM", name: "Dubai", flag: "🇦🇪" },
  { id: "BKP", name: "Kuwait", flag: "🇰🇼" },
  { id: "QE", name: "Qatar", flag: "🇶🇦" },
  { id: "NASDAQ", name: "US Market", flag: "🇺🇸" }
];

const SIGNAL_TYPES = [
  { id: "intraday", name: "Intraday" },
  { id: "short", name: "Short-term" },
  { id: "medium", name: "Medium-term" }
];

export default function ManualSignals() {
  const [formData, setFormData] = useState({
    market: "EGX",
    ticker: "",
    action: "BUY",
    entry_price: "",
    stop_loss: "",
    take_profit: "",
    signal_type: "medium",
    confidence_score: 80
  });
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [symbolsData, setSymbolsData] = useState({});
  const [filteredSymbols, setFilteredSymbols] = useState([]);
  const [selectedSymbol, setSelectedSymbol] = useState("");

  useEffect(() => {
    const loadSymbolsData = async () => {
      try {
        const response = await fetch('/symbols.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1);
        const symbolsMap = {};
        const marketSymbols = {};
        
        lines.forEach(line => {
          if (line.trim()) {
            const [symbol, market, name_ar, tradingview_symbol] = line.split(',');
            symbolsMap[symbol] = { market, name_ar, tradingview_symbol };
            if (!marketSymbols[market]) marketSymbols[market] = [];
            marketSymbols[market].push({ symbol, name_ar });
          }
        });
        
        setSymbolsData(symbolsMap);
        setFilteredSymbols(marketSymbols["EGX"] || []);
      } catch (error) {
        console.error('Error loading symbols:', error);
      }
    };

    loadSymbolsData();
  }, []);

  const handleMarketChange = (e) => {
    const market = e.target.value;
    setFormData({ ...formData, market });
    
    const marketSymbols = Object.keys(symbolsData)
      .filter(symbol => symbolsData[symbol].market === market)
      .map(symbol => ({ symbol, name_ar: symbolsData[symbol].name_ar }));
      
    setFilteredSymbols(marketSymbols);
    setSelectedSymbol("");
  };

  const toggleMarket = (marketId) => {
    if (formData.selectedMarkets.includes(marketId)) {
      setFormData({ ...formData, selectedMarkets: formData.selectedMarkets.filter(id => id !== marketId) });
    } else {
      setFormData({ ...formData, selectedMarkets: [...formData.selectedMarkets, marketId] });
    }
  };

  const validateForm = () => {
    const { ticker, action, entry_price, stop_loss, take_profit } = formData;
    
    if (!ticker.trim()) {
      throw new Error("يجب إدخال رمز السهم");
    }
    if (!entry_price) {
      throw new Error("يجب إدخال سعر الدخول");
    }
    if (!stop_loss) {
      throw new Error("يجب إدخال وقف الخسارة");
    }
    if (!take_profit) {
      throw new Error("يجب إدخال الهدف");
    }

    const entry = parseFloat(entry_price);
    const sl = parseFloat(stop_loss);
    const tp = parseFloat(take_profit);

    if (isNaN(entry) || isNaN(sl) || isNaN(tp)) {
      throw new Error("يجب إدخال أرقام صحيحة في حقول الأسعار");
    }

    if (action === "BUY") {
      if (tp <= entry) {
        throw new Error("في حالة الشراء: الهدف يجب أن يكون أعلى من سعر الدخول");
      }
      if (sl >= entry) {
        throw new Error("في حالة الشراء: وقف الخسارة يجب أن يكون أقل من سعر الدخول");
      }
    } else {
      if (tp >= entry) {
        throw new Error("في حالة البيع: الهدف يجب أن يكون أقل من سعر الدخول");
      }
      if (sl <= entry) {
        throw new Error("في حالة البيع: وقف الخسارة يجب أن يكون أعلى من سعر الدخول");
      }
    }

    return { entry, sl, tp };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      if (!selectedSymbol) {
        throw new Error("يجب اختيار سهم من القائمة");
      }

      const { entry, sl, tp } = validateForm();
      
      const symbolInfo = symbolsData[selectedSymbol];
      if (!symbolInfo) {
        throw new Error("السهم غير موجود");
      }

      const user = auth.currentUser;
      const userDoc = await getDocs(query(collection(db, 'users'), where('user_id', '==', user.uid)));
      let analystId = null;
      let expertId = null;
      
      if (!userDoc.empty) {
        const userData = userDoc.docs[0].data();
        analystId = userDoc.docs[0].id;
        expertId = userData.expert_id;
      }

      const signalData = {
        market: symbolInfo.market,
        ticker: selectedSymbol,
        ticker_name: symbolInfo.name_ar,
        action: formData.action,
        entry_price: entry,
        stop_loss: sl,
        take_profit: tp,
        signal_type: formData.signal_type,
        confidence_score: parseInt(formData.confidence_score),
        status: "active",
        source: "manual",
        analyst_id: analystId,
        expert_id: expertId,
        created_at: new Date().toISOString()
      };

      await addDoc(collection(db, "signals_v2"), signalData);
      setMessage("✅ التوصية أُدخلت بنجاح! ستظهر في الواجهة فورًا.");
      
      setSelectedSymbol("");
      setFormData({
        market: "EGX",
        ticker: "",
        action: "BUY",
        entry_price: "",
        stop_loss: "",
        take_profit: "",
        signal_type: "medium",
        confidence_score: 80
      });

    } catch (err) {
      console.error(err);
      setMessage(`❌ خطأ: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '700px', margin: '0 auto' }}>
      <h2 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        إدخال توصية يدوية
      </h2>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          borderRadius: '8px', 
          backgroundColor: message.includes('✅') ? '#f0fdf4' : '#fef2f2',
          color: message.includes('✅') ? '#166534' : '#b91c1c',
          marginBottom: '20px',
          border: message.includes('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
        }}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        {/* السوق والسهم */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '16px', marginBottom: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              السوق
            </label>
            <select
              name="market"
              value={formData.market}
              onChange={handleMarketChange}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            >
              {MARKETS.map(market => (
                <option key={market.id} value={market.id}>
                  {market.flag} {market.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              رمز السهم *
            </label>
            <select
              value={selectedSymbol}
              onChange={(e) => {
                const symbol = e.target.value;
                setSelectedSymbol(symbol);
                setFormData({ ...formData, ticker: symbol });
              }}
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            >
              <option value="">اختر السهم</option>
              {filteredSymbols.map(item => (
                <option key={item.symbol} value={item.symbol}>
                  {item.symbol} - {item.name_ar}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* نوع التوصية */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            نوع التوصية
          </label>
          <div style={{ display: 'flex', gap: '12px' }}>
            {SIGNAL_TYPES.map(type => (
              <label key={type.id} style={{ 
                padding: '8px 16px', 
                border: formData.signal_type === type.id ? '2px solid #1e40af' : '1px solid #ddd',
                borderRadius: '6px',
                cursor: 'pointer',
                backgroundColor: formData.signal_type === type.id ? '#eff6ff' : 'white'
              }}>
                <input
                  type="radio"
                  name="signal_type"
                  value={type.id}
                  checked={formData.signal_type === type.id}
                  onChange={(e) => setFormData({ ...formData, signal_type: e.target.value })}
                  style={{ display: 'none' }}
                />
                {type.name}
              </label>
            ))}
          </div>
        </div>

        {/* اتجاه التوصية */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            الاتجاه
          </label>
          <div style={{ display: 'flex', gap: '12px' }}>
            <label style={{ 
              padding: '8px 16px', 
              border: formData.action === 'BUY' ? '2px solid #16a34a' : '1px solid #ddd',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: formData.action === 'BUY' ? '#dcfce7' : 'white',
              color: formData.action === 'BUY' ? '#166534' : '#1e293b'
            }}>
              <input
                type="radio"
                name="action"
                value="BUY"
                checked={formData.action === 'BUY'}
                onChange={(e) => setFormData({ ...formData, action: e.target.value })}
                style={{ display: 'none' }}
              />
              شراء
            </label>
            <label style={{ 
              padding: '8px 16px', 
              border: formData.action === 'SELL' ? '2px solid #dc2626' : '1px solid #ddd',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: formData.action === 'SELL' ? '#fef2f2' : 'white',
              color: formData.action === 'SELL' ? '#991b1b' : '#1e293b'
            }}>
              <input
                type="radio"
                name="action"
                value="SELL"
                checked={formData.action === 'SELL'}
                onChange={(e) => setFormData({ ...formData, action: e.target.value })}
                style={{ display: 'none' }}
              />
              بيع
            </label>
          </div>
        </div>

        {/* الأسعار */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '24px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              سعر الدخول *
            </label>
            <input
              type="number"
              name="entry_price"
              value={formData.entry_price}
              onChange={(e) => setFormData({ ...formData, entry_price: e.target.value })}
              required
              step="0.01"
              min="0"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              وقف الخسارة *
            </label>
            <input
              type="number"
              name="stop_loss"
              value={formData.stop_loss}
              onChange={(e) => setFormData({ ...formData, stop_loss: e.target.value })}
              required
              step="0.01"
              min="0"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
              الهدف *
            </label>
            <input
              type="number"
              name="take_profit"
              value={formData.take_profit}
              onChange={(e) => setFormData({ ...formData, take_profit: e.target.value })}
              required
              step="0.01"
              min="0"
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px'
              }}
            />
          </div>
        </div>

        {/* درجة الثقة */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
            درجة الثقة (%)
          </label>
          <input
            type="range"
            name="confidence_score"
            min="1"
            max="100"
            value={formData.confidence_score}
            onChange={(e) => setFormData({ ...formData, confidence_score: e.target.value })}
            style={{ width: '100%' }}
          />
          <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '4px' }}>
            {formData.confidence_score}%
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: loading ? '#94a3b8' : '#1e40af',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'جاري الإدخال...' : 'إدخال التوصية'}
        </button>
      </form>
    </div>
  );
}